<div class="callout-hint callout {{class}}" [class.hint-hover]="clickTarget !== null" [class.internal]="isInternalPortal" [class.as-button]="version === 'button'">
  <div class="cell hint-wrapper" (click)="clickTarget !== null ? onClickToLeadModule() : null">
    @if (showPdfAndPrintIcons) {
      <div class="icon-wrapper">
        @if (version === 'default') {
          <i class="icon-print" ></i>
        }
        <i class="icon-pdf"></i>
      </div>
    }
    <p [innerHTML]="textkey | translate"></p>
  </div>
  @if(closable) {
    <button class="close-button" aria-label="schliessen" type="button" (click)="closeHint()">
      <i class="icon-x"></i>
    </button>
  }
</div>
